import axios from 'axios'

export default {
    state: {
        authCompany: localStorage.getItem('auth_company') && JSON.parse(localStorage.getItem('auth_company')) || null,
        authStaffMember: localStorage.getItem('auth_staff_member') && JSON.parse(localStorage.getItem('auth_staff_member')) || null,
        authToken: localStorage.getItem('auth_token') || null,
    },
    getters: {
        authCompany: state => state.authCompany,
        authStaffMember: state => state.authStaffMember,
        authToken: state => state.authToken,
    },
    mutations: {
        authLogin(state, {company, staffMember, token, languageCode, countryCode}) {
            localStorage.setItem('auth_company', JSON.stringify(company));
            localStorage.setItem('auth_staff_member', JSON.stringify(staffMember));
            localStorage.setItem('auth_token', token);
            localStorage.setItem('language_code', languageCode);
            localStorage.setItem('country_code', countryCode);

            state.authCompany = company;
            state.authStaffMember = staffMember;
            state.authToken = token;
        },
        authLogout(state) {
            localStorage.removeItem('auth_staff_member');
            localStorage.removeItem('auth_token');

            state.authStaffMember = null;
            state.authToken = null;
        },
        authSetCompany(state, {company}) {
            localStorage.setItem('auth_company', JSON.stringify((company)));

            state.authCompany = company;
        },
        authRemoveCompany(state) {
            localStorage.removeItem('auth_company');

            state.authCompany = null;
        }
    },
    actions: {
        async authLogin({commit}, authData) {
            await this._vm.$recaptchaLoaded();
            const token = await this._vm.$recaptcha('login');

            const response = await axios.post('/auth/login', {
                companyCode: authData.companyCode,
                username: authData.username,
                password: authData.password,
                recaptchaToken: token
            });
            commit("authLogin", {
                company: response.data.company,
                staffMember: response.data.staffMember,
                token: response.data.token,
                languageCode: response.data.languageCode,
                countryCode: response.data.countryCode
            });
            return response.data;
        },
        async authLogout({commit}) {
            commit("authLogout");
            await this._vm.$apolloClient.resetStore();
        },
        authRemoveCompany({commit}) {
            commit("authRemoveCompany");
        }
    }
}
